import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import {
  KeyboardDatePicker
} from '@material-ui/pickers';

import {
  Box,
  Link,
  Card,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  makeStyles,
  Grid,
  colors,
  Avatar,
  Icon,
  Typography,
  Button,
  FormControl
} from '@material-ui/core';

import AutorenewIcon from '@material-ui/icons/Autorenew';
import SaveIcon from '@material-ui/icons/Save';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200],
    width: 58,
    height: 58
  },
  iconoperation: {
    width: 45,
    height: 45
  },
  baroperation: {
    width: '100%',
    minHeight: 65
  }
}));

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const Toolbar = ({ icon, item, resultset, resultModes, vision, visions, selectedMode, openCreation, changeFilter, openExport }) => {

  const classes = useStyles();

  const [startDateTime, setStartDateTime] = useState(defaultStartDateTime);
  const [endDateTime, setEndDateTime] = useState(defaultEndDateTime);
  const [keyword, setKeyword] = useState('');
  const [query, setQuery] = useState(vision);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [option, setOption] = useState(1);

  const changeStartDatetime = (value) => {
    setStartDateTime(value);
    setPage(0);
    changeFilter(value,
      endDateTime,
      query,
      keyword,
      page,
      rows,
      option);
  }

  const changeEndDatetime = (value) => {
    setEndDateTime(value);
    setPage(0);
    changeFilter(startDateTime,
      value,
      query,
      keyword,
      page,
      rows,
      option);
  }

  const changeQuery = (event) => {
    setQuery(event.target.value);
    var opt = event.target.value.options[0].id;
    setOption(opt);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      event.target.value,
      keyword,
      page,
      rows,
      opt);
  }

  const changeOption = (event) => {
    setOption(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      page,
      rows,
      event.target.value);
  }

  const changeKeyword = (event) => {
    setKeyword(event.target.value);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      event.target.value,
      page,
      rows,
      option);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      newPage,
      rows,
      option);
  };

  const handleChangeRowsPerPage = (event) => {
    var rowsPerPage = parseInt(event.target.value, 10);
    setRows(rowsPerPage);
    setPage(0);
    changeFilter(startDateTime,
      endDateTime,
      query,
      keyword,
      page,
      rowsPerPage,
      option);
  };

  return (
    <Fragment>
      <Box className={classes.baroperation}>

        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item
            md="auto"
            xs="auto">
            <Avatar variant="rounded"
              className={classes.avatar}
            >
              {<Icon className={classes.iconoperation} component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
            </Avatar>

          </Grid>

          <Grid item
            md="auto"
            xs="auto">
            <Typography
              color="primary"
              variant="h5"
            >
              Você esta na área de <b>{<Link color="inherit" href="/mgt/main">MANUTENÇÃO</Link>}</b>. A operação padrão é <b> {localStorage.getItem('company')}</b>
            </Typography>

            <Typography
              color="secondary"
              variant="h4"
            >
              <b>Relatórios</b>
            </Typography>

          </Grid>
        </Grid>
      </Box>


      <Card>
        <CardContent>
          <Grid container
            fullWidth
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-end"
          >
            <Grid item
              md={12}
              xs={12}>

              <Card>
                <CardContent>
                  <Grid container
                    fullWidth
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    alignContent="flex-start"
                  >
                    <Grid item
                      xs={12}
                    >
                      <Grid container justifyContent="flex-start" spacing={1}>
                        <Grid item
                          md={3}
                          xs={12}
                        >
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel shrink htmlFor="query">Relatório</InputLabel>
                            <Select notched
                              required={true}
                              fullWidth={true}
                              label="Relatório"
                              variant="outlined"
                              id="query"
                              name="query"
                              value={query}
                              onChange={changeQuery}
                              inputProps={{
                                name: 'query',
                                id: 'query',
                              }}
                            >
                              {visions.map((view) => (
                                <MenuItem disabled={view.id == 8 && localStorage.getItem('profile') == 'ADM'} key={view.id} value={view}> {view.name}</MenuItem>
                              ))}

                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item
                          md={2}
                          xs={12}
                        >
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel shrink htmlFor="option">Tipo</InputLabel>
                            <Select notched
                              required={true}
                              fullWidth={true}
                              label="Tipo"
                              variant="outlined"
                              id="option"
                              name="option"
                              value={option}
                              onChange={changeOption}
                              inputProps={{
                                name: 'option',
                                id: 'option',
                              }}
                            >
                              {query.options.map((opt) => (
                                <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>
                              ))}

                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item
                          md={2}
                          xs={12}>
                          <KeyboardDatePicker
                            disabled={(query.history == 0 && option != 3)}
                            margin="none"
                            cancelLabel="Cancelar"
                            id="startDateTime"
                            name="startDateTime"
                            label="Data Inicial"
                            format="DD/MM/YYYY"
                            value={startDateTime}
                            inputVariant="outlined"
                            onChange={changeStartDatetime}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>

                        <Grid item
                          md={2}
                          xs={12}>
                          <KeyboardDatePicker
                            disabled={(query.history == 0 && option != 3)}
                            margin="none"
                            cancelLabel="Cancelar"
                            id="endDateTime"
                            name="endDateTime"
                            label="Data Final"
                            inputVariant="outlined"
                            format="DD/MM/YYYY"
                            value={endDateTime}
                            onChange={changeEndDatetime}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        </Grid>


                        <Grid item
                          md={3}
                          xs={12}
                        >

                          {(resultModes[selectedMode].create != LEVEL_ACCESS_HIDE) ? (
                            <Box mt={2} >
                              <Button
                                color="secondary"
                                disabled={resultModes[selectedMode].create == LEVEL_ACCESS_DISABLED}
                                size="small"
                                variant="contained"
                                startIcon={<AutorenewIcon />}
                                onClick={() => { openCreation(item) }}>
                                Gerar Relatório
                              </Button>
                              &nbsp;
                              {(vision.export) ? (
                                <Button
                                  color="secondary"
                                  disabled={resultModes[selectedMode].export == LEVEL_ACCESS_DISABLED}
                                  size="small"
                                  variant="contained"
                                  startIcon={<SaveIcon />}
                                  onClick={() => { openExport(item) }}>
                                  Exportar
                                </Button>
                              ) : ""}
                            </Box>
                          ) : ('')}

                        </Grid>


                      </Grid>

                    </Grid>

                  </Grid>

                </CardContent>

              </Card>

            </Grid>

          </Grid>

        </CardContent>

      </Card>


    </Fragment>

  );
};


Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
